import { SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="30px"
    height="30px"
    viewBox="0 0 80 80"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Icon-Architecture/64/Arch_Amazon-Managed-Service-for-Grafana_64</title>
    <defs>
      <linearGradient x1="0%" y1="100%" x2="100%" y2="0%" id="linearGradient-1">
        <stop stopColor="#B0084D" offset="0%"></stop>
        <stop stopColor="#FF4F8B" offset="100%"></stop>
      </linearGradient>
    </defs>
    <g
      id="Icon-Architecture/64/Arch_Amazon-Managed-Service-for-Grafana_64"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Rectangle" fill="url(#linearGradient-1)">
        <rect x="0" y="0" width="80" height="80"></rect>
      </g>
      <g
        id="Icon-Service/64/Amazon-Managed-Service-for-Grafana_64"
        transform="translate(8.000000, 8.000000)"
        fill="#FFFFFF"
      >
        <path
          d="M17.9996175,44.0003564 L19.9996175,44.0003564 L19.9996175,33.0003564 L17.9996175,33.0003564 L17.9996175,44.0003564 Z M38.9996175,44.0003564 L40.9996175,44.0003564 L40.9996175,33.0003564 L38.9996175,33.0003564 L38.9996175,44.0003564 Z M31.9996175,44.0003564 L33.9996175,44.0003564 L33.9996175,19.0003564 L31.9996175,19.0003564 L31.9996175,44.0003564 Z M24.9996175,44.0003564 L26.9996175,44.0003564 L26.9996175,28.0003564 L24.9996175,28.0003564 L24.9996175,44.0003564 Z M57.9996175,50.1933564 L22.4196175,57.8863564 L6.11961749,35.8333564 L16.6846175,6.0613564 L39.0496175,7.9243564 L40.0016175,25.0563564 C40.0166175,25.3303564 40.1446175,25.5863564 40.3546175,25.7633564 C40.5646175,25.9413564 40.8396175,26.0253564 41.1106175,25.9943564 L57.9996175,24.1173564 L57.9996175,50.1933564 Z M59.6666175,22.2553564 C59.4536175,22.0653564 59.1706175,21.9763564 58.8896175,22.0063564 L41.9396175,23.8903564 L40.9976175,6.9443564 C40.9706175,6.4463564 40.5796175,6.0453564 40.0826175,6.0033564 L16.0826175,4.0033564 C15.6236175,3.9663564 15.2086175,4.2383564 15.0576175,4.6663564 L4.05761749,35.6663564 C3.94661749,35.9793564 3.99761749,36.3273564 4.19661749,36.5943564 L21.1966175,59.5943564 C21.3866175,59.8533564 21.6866175,60.0003564 21.9996175,60.0003564 C22.0706175,60.0003564 22.1406175,59.9933564 22.2106175,59.9783564 L59.2106175,51.9783564 C59.6716175,51.8783564 59.9996175,51.4713564 59.9996175,51.0003564 L59.9996175,23.0003564 C59.9996175,22.7153564 59.8786175,22.4443564 59.6666175,22.2553564 L59.6666175,22.2553564 Z"
          id="Fill-5"
        ></path>
      </g>
    </g>
  </svg>
);

export default SvgComponent;
